import UserReport from "@/services/api/userReport";
import { handleResponse } from "@/services/axios";
import { saveAsExcelFile } from "@/services/excelService/excelSevice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface Report {
    userReport: any[];
    userReportData: any[];
    loading: {
        userReport: boolean;
        userReportData: boolean;
        userReportExport: boolean;
    };
    error: string | null;
}

const initialState: Report = {
    userReport: [],
    userReportData: [],
    loading: {
        userReport: false,
        userReportData: false,
        userReportExport: false,
    },
    error: null,
}

export const getUserReportDetails = createAsyncThunk(
    "userReport/getUserReportDetails",
    async (params: any, { rejectWithValue }) => {
        try {
            const response = await UserReport.getUserReportDetails(params);
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message || "Failed to fetch user report"
            );
        }
    }
);

export const getUserReportData = createAsyncThunk(
    "userReport/getUserReportData",
    async (params: any, { rejectWithValue }) => {
        try {
            const response = await UserReport.getUserReportData(params);
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message || "Failed to fetch user report data"
            );
        }
    }
);

export const getUserReportExport = createAsyncThunk(
    "userReport/getUserReportExport",
    async (params: any, { rejectWithValue }) => {
        try {
            const response = await UserReport.getUserReportExport(params);
            return saveAsExcelFile(response, "User_Report");
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message || "Failed to fetch user report export"
            );
        }
    }
);

const userReportSlice = createSlice({
    name: "userReport",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserReportDetails.pending, (state) => {
                state.loading.userReport = true;
            })
            .addCase(getUserReportDetails.fulfilled, (state, action) => {
                state.loading.userReport = false;
                state.userReport = action.payload || [];
            })
            .addCase(getUserReportDetails.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading.userReport = false;
            })

            .addCase(getUserReportData.pending, (state) => {
                state.loading.userReportData = true;
                state.userReportData = [];
            })
            .addCase(getUserReportData.fulfilled, (state, action) => {
                state.loading.userReportData = false;
                state.userReportData = action.payload || [];
            })
            .addCase(getUserReportData.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading.userReportData = false;
            })

            .addCase(getUserReportExport.pending, (state) => {
                state.loading.userReportExport = true;
            })
            .addCase(getUserReportExport.fulfilled, (state) => {
                state.loading.userReportExport = false;
            })
            .addCase(getUserReportExport.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading.userReportExport = false;
            });
    },
});

export default userReportSlice.reducer;